import { useQuery } from '@tanstack/react-query'
import { Select, type SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { integrationRpcPresetsListOptions } from 'src/api/main'

import { IndustrySelectItem } from '../'

import { demoPresetsInfo } from './demoPresetsInfo'

// Declining demo data is not something to build; the backend rejects it.
const NO_DATA_PRESET_CODENAME = 'no_data'

export const IndustrySelect = (props: SelectProps) => {
  const { t } = useTranslation()

  const { data, isLoading } = useQuery(integrationRpcPresetsListOptions())

  const getOrder = (codename: string) =>
    codename in demoPresetsInfo
      ? demoPresetsInfo[codename as keyof typeof demoPresetsInfo].order
      : Number.MAX_SAFE_INTEGER

  const options: SelectProps['options'] = data?.results
    ?.filter(({ codename }) => codename !== NO_DATA_PRESET_CODENAME)
    .sort((a, b) => getOrder(a.codename) - getOrder(b.codename))
    .map(({ id, codename }) => ({
      label: <IndustrySelectItem codename={codename} title={t(codename)} />,
      value: id
    }))

  return (
    <Select
      options={options}
      placeholder={t('please_select')}
      allowClear
      loading={isLoading}
      {...props}
    />
  )
}
